import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { InteractiveListBaseItem } from './InteractiveListBaseItem.js';
import { jsx } from '@emotion/react';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '@indeed/ifl-icons';
import '../Text/Text.js';
import '../../utils/createResponsive.js';
import '../Flex/Flex.js';
import '../Box/Box.js';

const INTERACTIVE_LIST_OPTION_DEFAULT_TAG = "li";
const InteractiveListOption = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    as = INTERACTIVE_LIST_OPTION_DEFAULT_TAG,
    children,
    contentAfter,
    contentBefore,
    selectionType,
    selected = false,
    supportiveContent,
    ...remainingProps
  } = props;
  return jsx(InteractiveListBaseItem, _extends({
    as: as,
    contentAfter: contentAfter,
    contentBefore: contentBefore,
    isOption: true,
    ref: ref,
    selectionType: selectionType,
    selected: selected,
    supportiveContent: supportiveContent
  }, remainingProps), children);
});
InteractiveListOption.displayName = "InteractiveListOption";

export { InteractiveListOption };
